import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import PutAwayRtnDetailBoardActions, {
  PutAwayRtnDetailBoardTypes
} from '../Stores/PutAwayRtnDetailBoard/Actions';

const getAppStore = state => state.app;

export function* putAwayRtnDetailBoardFetchWipGdsRcpt({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardFetchWipGdsRcptLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `gdsRcpt/indexRtnToDoPutAway/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardFetchWipGdsRcptSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardFetchWipGdsRcptLoading(false));
  }
}

export function* putAwayRtnDetailBoardFetchWipPutAway({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardFetchWipPutAwayLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `putAway/indexRtnToDoWhseJob/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardFetchWipPutAwaySuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardFetchWipPutAwayLoading(false));
  }
}

export function* putAwayRtnDetailBoardFetchWipWhseJob({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardFetchWipWhseJobLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `whseJob/indexRtnToDoPutAway/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardFetchWipWhseJobSuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardFetchWipWhseJobLoading(false));
  }
}

export function* putAwayRtnDetailBoardFetchCompletePutAway({
  currentPage,
  sorts,
  filters,
  pageSize
}) {
  try {
    yield put(PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardFetchCompletePutAwayLoading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `putAway/indexRtnTodayCompleted/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardFetchCompletePutAwaySuccess(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardFetchCompletePutAwayLoading(false));
  }
}

export function* putAwayRtnDetailBoardShowWipGdsRcptSummary({ docId }) {
  try {
    yield put(PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardShowWipGdsRcptSummaryLoading(true));

    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `gdsRcpt/showSummary/${docId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      yield put(
        PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardShowWipGdsRcptSummarySuccess(result.data)
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(
      PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardShowWipGdsRcptSummaryLoading(false)
    );
  }
}

export function* putAwayRtnDetailBoardShowWipPutAwaySummary({ docId }) {
  try {
    yield put(PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardShowWipPutAwaySummaryLoading(true));

    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `putAway/showSummary/${docId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      yield put(
        PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardShowWipPutAwaySummarySuccess(result.data)
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(
      PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardShowWipPutAwaySummaryLoading(false)
    );
  }
}

export function* putAwayRtnDetailBoardShowWipWhseJobSummary({ docId }) {
  try {
    yield put(PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardShowWipWhseJobSummaryLoading(true));

    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `whseJob/showPutAwaySummary/${docId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      yield put(
        PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardShowWipWhseJobSummarySuccess(result.data)
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(
      PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardShowWipWhseJobSummaryLoading(false)
    );
  }
}

export function* putAwayRtnDetailBoardShowCompletePutAwaySummary({ docId }) {
  try {
    yield put(
      PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardShowCompletePutAwaySummaryLoading(true)
    );

    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `putAway/showSummary/${docId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      yield put(
        PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardShowCompletePutAwaySummarySuccess(
          result.data
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(
      PutAwayRtnDetailBoardActions.putAwayRtnDetailBoardShowCompletePutAwaySummaryLoading(false)
    );
  }
}

export const saga = [
  takeLatest(
    PutAwayRtnDetailBoardTypes.PUT_AWAY_RTN_DETAIL_BOARD_FETCH_WIP_GDS_RCPT,
    putAwayRtnDetailBoardFetchWipGdsRcpt
  ),

  takeLatest(
    PutAwayRtnDetailBoardTypes.PUT_AWAY_RTN_DETAIL_BOARD_FETCH_WIP_PUT_AWAY,
    putAwayRtnDetailBoardFetchWipPutAway
  ),

  takeLatest(
    PutAwayRtnDetailBoardTypes.PUT_AWAY_RTN_DETAIL_BOARD_FETCH_WIP_WHSE_JOB,
    putAwayRtnDetailBoardFetchWipWhseJob
  ),

  takeLatest(
    PutAwayRtnDetailBoardTypes.PUT_AWAY_RTN_DETAIL_BOARD_FETCH_COMPLETE_PUT_AWAY,
    putAwayRtnDetailBoardFetchCompletePutAway
  ),

  takeLatest(
    PutAwayRtnDetailBoardTypes.PUT_AWAY_RTN_DETAIL_BOARD_SHOW_WIP_GDS_RCPT_SUMMARY,
    putAwayRtnDetailBoardShowWipGdsRcptSummary
  ),

  takeLatest(
    PutAwayRtnDetailBoardTypes.PUT_AWAY_RTN_DETAIL_BOARD_SHOW_WIP_PUT_AWAY_SUMMARY,
    putAwayRtnDetailBoardShowWipPutAwaySummary
  ),

  takeLatest(
    PutAwayRtnDetailBoardTypes.PUT_AWAY_RTN_DETAIL_BOARD_SHOW_WIP_WHSE_JOB_SUMMARY,
    putAwayRtnDetailBoardShowWipWhseJobSummary
  ),

  takeLatest(
    PutAwayRtnDetailBoardTypes.PUT_AWAY_RTN_DETAIL_BOARD_SHOW_COMPLETE_PUT_AWAY_SUMMARY,
    putAwayRtnDetailBoardShowCompletePutAwaySummary
  )
];
